import "jquery.autocomplete";

$(function () {
    $("._page-criar-moodboard").each(function () {
        const page = $(this);
        let patternNames = [];
        let totalPatterns = page.find(".open-modal").length;
        let validatePatterns = false;
        let validaName = false;
        var positionGtag;

        page.find(".open-modal").on("click", function () {
            positionGtag = $(this).data("position");
            page.find(".modal-patterns").removeClass("hidden");
            page.find(".modal-patterns").data(
                "pattern",
                $(this).data("pattern")
            );
            page.find(".modal-patterns").data("index", $(this).data("index"));
            $("body").attr("overflow", "hidden");
            page.find(".open-modal").removeClass("editing");
            $(this).addClass("editing");
            patternNames = [];
        });

        page.find(".close-modal").on("click", function () {
            page.find(".modal-patterns").addClass("hidden");
            page.find(".open-modal").removeClass("editing");
            $("body").removeAttr("style");
        });

        page.find("input[name='busca']").on("keyup", function () {
            page.find(".pattern")
                .hide()
                .filter(
                    ":contains(" +
                        $(this)
                            .val()
                            .toLocaleLowerCase()
                            .replace(/\w\S*/g, (w) =>
                                w.replace(/^\w/, (c) => c.toUpperCase())
                            ) +
                        ")"
                )
                .show();
        });

        page.find("input[name='user_moodboard_name']").on("keyup", function () {
            let user_moodboard_name = $(this).val();
            page.find(".error-moodboard-name").remove();
            $.ajax({
                method: "POST",
                headers: {
                    "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
                },
                url: `${APP_URL}/criar-moodboard/valida-nome-moodboard`,
                data: {
                    user_moodboard_name,
                },
                beforeSend: function () {
                    validaName = false;
                },
                success: function (res) {
                    page.find(".error-moodboard-name").remove();

                    if (res) {
                        page.find("input[name='user_moodboard_name']")
                            .closest("header")
                            .after(
                                '<span class="error-moodboard-name block text-12 text-red mb-20">O nome <strong>' +
                                    user_moodboard_name +
                                    "</strong> já esta sendo utilizado</span>"
                            );
                    } else {
                        validaName = true;
                    }
                },
                error: function (res) {
                    console.error(res);
                },
            }).done(function (res) {
                if (validaName && validatePatterns) {
                    page.find(".send-form").removeAttr("disabled");
                } else {
                    page.find(".send-form").attr("disabled");
                }
            });
        });

        let slug = [
            { position: 1, slug: "" },
            { position: 2, slug: "" },
            { position: 3, slug: "" },
        ];

        page.find(".pattern").on("click", function () {
            if (!page.find(".modal-patterns").hasClass("totem")) {
                page.find(".modal-patterns").addClass("hidden");
                page.find(".open-modal").removeClass("editing");
                ga(
                    "send",
                    "event",
                    "click",
                    `criar_moodboard_passo_02_click_${$(this).data(
                        "slug"
                    )}_0${positionGtag}`
                );
            
            } else { 
                ga(
                    "send",
                    "event",
                    "click",
                    `totem_criar_moodboard_passo_02_click_${$(this).data(
                        "slug"
                    )}_0${positionGtag}`
                );
            }

            if ($(this).hasClass("totem")) {
                validaName = true;
            }

            $("body").removeAttr("style");

            $(`#${$(this).closest(".modal-patterns").data("pattern")}`).val(
                $(this).data("id")
            );

            $(`#${$(this).closest(".modal-patterns").data("pattern")}`).data(
                "name",
                $(this).data("name")
            );

            if (
                $(this).closest(".modal-patterns").data("pattern") ==
                "background_pattern_id"
            ) {
                page.find("#background_pattern_id").data(
                    "name",
                    $(this).data("name")
                );
            } else {
                $(
                    `#${$(this).closest(".modal-patterns").data("pattern")}`
                ).data("name", $(this).data("name"));
            }

            let patterns = [];
            let moodboard_template_id = page
                .find('input[name="moodboard_template_id"]')
                .val();

            slug.forEach((el, index) => {
                if (el.position === positionGtag) {
                    slug[index].slug = $(this).data("slug");
                }
            });

            sessionStorage.setItem("slugs", JSON.stringify(slug));

            page.find(".patternsid").each(function () {
                if ($(this).find("input").val()) {
                    patterns.push({
                        pattern: $(this).find("input").val(),
                        position: $(this).find("input").data("position"),
                    });
                }
            });

            $.ajax({
                method: "POST",
                headers: {
                    "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
                },
                url: `${APP_URL}/criar-moodboard/gerar-previa`,
                data: {
                    moodboard_template_id,
                    patterns,
                },
                beforeSend: function () {
                    page.find(".loading").removeClass("hidden");
                },
                success: function (res) {
                    page.find(".loading").addClass("hidden");
                    $("#template_temp").attr("src", res);
                },
                error: function (res) {
                    console.error(res);
                },
            });

            if ($("#background_pattern_id").data("name")) {
                patternNames.push(
                    page.find("#background_pattern_id").data("name")
                );
            }

            $("input[name='pattern_id[]']").each(function () {
                if ($(this).data("name")) {
                    patternNames.push($(this).data("name"));
                }
            });

            if (patternNames.length >= totalPatterns) {
                validatePatterns = true;
            }

            if (validaName && validatePatterns) {
                page.find(".send-form").removeAttr("disabled");
                page.find(".text-finish-step").text(
                    "Clique em concluir ou continue editando"
                );
            }

            page.find(".patterns-name").text(patternNames.join(" + "));
        });

        page.find("#send-aproove").on("submit", function (event) {
            event.preventDefault();

            let data = $(this).serializeArray();

            $.ajax({
                method: "POST",
                url: `${APP_URL}/criar-moodboard/salvar-aprovacao`,
                data: data,
                beforeSend: function () {
                    page.find("#send-aproove button span")
                        .text("ENVIANDO")
                        .attr("disabled", "disabled");
                    page.find("#send-aproove .loading").show();
                },
                success: function (res) {
                    page.find(".send-ok").show();
                    page.find(".header").hide();
                    page.find("#send-aproove").hide();

                    $([document.documentElement, document.body]).animate(
                        {
                            scrollTop: $("#app").offset().top,
                        },
                        400
                    );
                },
                error: function (res) {
                    console.error(res);
                },
            });
        });

        let environments = [];
        let totalPatternsMoodboard = "0";

        page.find("#aplicar_ambiente").on("click", function () {
            $.ajax({
                method: "GET",
                url: `${APP_URL}/simulator-api/environments`,
                beforeSend: function () {
                    $(".list-envoironments").html("");
                    $(".list-options").html("");
                    $(".step-2").addClass("hidden");
                    $(".step-1").removeClass("hidden");
                },
                success: function (res) {
                    environments = res.environments;
                    totalPatternsMoodboard = document
                        .querySelector(".patterns-name-total")
                        .innerText.split(" + ").length;

                    console.log(totalPatternsMoodboard);

                    environments.forEach((environment, index) => {
                        let totalEnvironment = environment.environment_options.filter(
                            (el) => {
                                if (totalPatternsMoodboard === 2) {
                                    return el.third_trigger_x === null;
                                } else {
                                    return el.third_trigger_x !== null;
                                }
                            }
                        );

                        let template = `
                            <a class="bg-white flex justify-center flex-col content-center items-center cursor-pointer h-172 group envoironment-button border border-gray40" data-index="${index}" data-ambiente="${environment.slug}">
                                <img
                                    src=${MIX_AWS_URL}/${environment.image}
                                    class="w-94 h-96 group-hover:scale-125 transition-all duration-300"
                                />
                                <span class="block text-center text-24 text-gray90 font-light">
                                    ${environment.name}
                                </span>
                                <p class="text-gray90 text-12">
                                    ${totalEnvironment.length} ambientes disponíveis
                                </p>
                            </a>
                        `;

                        $("#modal").removeClass("hidden");

                        $(".list-envoironments").append(template);
                    });
                },
                error: function (res) {
                    console.error(res);
                },
            });
        });

        $("body").on("click", ".envoironment-button", function () {
            let options = environments[
                $(this).data("index")
            ].environment_options.filter((el) => {
                if (totalPatternsMoodboard === 2) {
                    return el.third_trigger_x === null;
                } else {
                    return el.third_trigger_x !== null;
                }
            });

            let ambiente = $(this).data("ambiente");
            let patternsJson = JSON.parse(sessionStorage.slugs);

            let patternsFull = patternsJson.map((el) => {
                return el.slug;
            });

            let patternsWithOutLast = patternsJson.map((el) => {
                return el.slug;
            });

            patternsWithOutLast.pop();

            let urlPatternsFull = patternsFull.join("|");
            let urlPatternsWithOutLast = patternsWithOutLast.join("|");

            let area = window.location.href.includes("totem") ? "/totem" : "";

            options.forEach((option) => {
                let template = ``;
                if (option.third_trigger_x === null) {
                    template = `
                    <div class="image-container">
                        <a href="${APP_URL}${area}/simulador/${ambiente}/${option.slug}/${urlPatternsWithOutLast}" class="image-link">
                            <img src=${MIX_AWS_URL}/${option.image} />
                        </a>
                    </div>
                    `;
                } else {
                    template = `
                    <div class="image-container">
                        <a href="${APP_URL}${area}/simulador/${ambiente}/${option.slug}/${urlPatternsFull}" class="image-link">
                            <img src=${MIX_AWS_URL}/${option.image} />
                        </a>
                    </div>
                    `;
                }

                $(".step-1").addClass("hidden");
                $(".step-2").removeClass("hidden");

                $(".list-options").append(template);
            });
        });
    });
});
